enum SimpleLoyaltySignupMode {
  Off = 0,
  OrderSummary = 1,
  PaymentCompleted = 2,
  PaymentCompletedForced = 3,
}

export { SimpleLoyaltySignupMode };
